export default {"src":"/_next/static/media/aywa.850e866f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};